import axios from '../config/axiosPrivate';

export const getAIFeedbacks = async (params: {
  community_id?: number;
  action_plan_id?: number;
  recommendation_overview_id?: number;
  cmi_digest_run_community_id?: number;
  feature_type?: string;
}) => {
  const response = await axios.get('/feedbacks/', { params });
  return response.data;
};

export const createAIFeedback = async (payload: any) => {
  const response = await axios.post('/feedbacks/', {
    feature_type: payload.featureType,
    feedback_type: payload.feedbackType,
    comment: payload.comment,
    source_url: payload.sourceUrl,
    recommendation_overview: payload.recommendationOverview,
    action_plan: payload.actionPlan,
    cmi_digest_run_community: payload.cmiDigestRunCommunity,
    community: payload.community,
  });
  return response.data;
};

export const updateAIFeedback = async (id: number, payload: { feedbackType: string; comment: string }) => {
  const response = await axios.patch(`/feedbacks/${id}/`, {
    feedback_type: payload.feedbackType,
    comment: payload.comment,
  });
  return response.data;
};

export const deleteAIFeedback = async (id: number) => {
  await axios.delete(`/feedbacks/${id}/`);
};
